import { ExclamationCircleFilled } from "@ant-design/icons"
import { Expense, Transaction } from "@finway-group/shared/lib/models"
import { formatCurrencyNumber, toDinero } from "@finway-group/shared/lib/utils"
import { Alert } from "antd"
import React from "react"
import { Trans, useTranslation } from "react-i18next"
import { getTransactionRawContent } from "~Shared/utils/transaction.utils"

export const AutoGeneratedExpenseAmountBanner = ({ expense }: { expense: Expense }) => {
    const { t } = useTranslation()

    const transaction = expense?.matchedTransactions?.[0]
    const transactionRawContent = getTransactionRawContent(transaction as Transaction)
    const isTransactionSourceAmountMismatch =
        transactionRawContent?.sourceAmount && !toDinero(Math.abs(transactionRawContent?.sourceAmount)).equalsTo(toDinero(Math.abs(expense.totalGrossPrice)))
    const shouldShowAutoGeneratedExpenseAmountBanner = expense.isAutoGenerated && expense.card && expense.matchedTransactions.length > 0 && isTransactionSourceAmountMismatch

    if (!shouldShowAutoGeneratedExpenseAmountBanner) {
        return null
    }

    return (
        <Alert
            showIcon
            type="error"
            icon={<ExclamationCircleFilled />}
            message={
                <>
                    <Trans
                        t={t}
                        i18nKey="info:auto_generated_request_gross_amount_mismatch"
                        values={{
                            transactionAmount: formatCurrencyNumber({
                                value: Math.abs(transactionRawContent?.sourceAmount || 0) as number,
                                currency: expense.currency,
                            }),
                        }}
                    />
                </>
            }
        />
    )
}
